import { HttpEvent, HttpEventType } from '@angular/common/http';
import { EditorConfigService } from './../../../../shared/services/angular-editor.service';
import { MediaFileService } from './../../../../shared/services/media-file.service';
import { NoticeBoardCategoryService } from './../../../../shared/services/notice-board-category.service';
import { NoticeBoardService } from './../../../../shared/services/notice-board.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { IMediaFile } from '../../../../_models/cms/IMediaFile';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { INoticeBoard, INoticeBoardCategory } from '../../../../_models/cms/INoticeBoard';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;

@Component({
  selector: 'app-notice-board-form',
  templateUrl: './notice-board-form.component.html'
})
export class NoticeBoardFormComponent implements OnInit {


  loading: boolean;
  title: string = 'Add Notice';
  noticeBoard: INoticeBoard;
  noticeBoardForm: FormGroup;
  noticeBoardCategories: INoticeBoardCategory[];
  selectedMediaFile: IMediaFile | null;
  id;
  sub: Subscription;

  model: NgbDateStruct;

  barWidth: number = 0;
  isProgress: boolean = false;
  fileToUpload: File = null;

  editorConfigOption: AngularEditorConfig;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: NoticeBoardService,
    private noticeBoardCategoryService: NoticeBoardCategoryService,
    private mediaFileService: MediaFileService,
    private editorConfigService: EditorConfigService) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createNoticeBoardForm();
    this.bindDropDown();
    if (this.id) this.service.get(this.id).subscribe((response: INoticeBoard) => {
      if (response) {
        this.noticeBoard = response;
        this.title = 'Edit Notice';
        if (response.mediaFile) this.selectedMediaFile = response.mediaFile;
        this.setValueNoticeBoardForm();
      }
    });

    this.editorConfigOption = this.editorConfigService.getOption();

    this.sub = this.mediaFileService.selectedMediaFileChanges$.subscribe(
      selectedMediaFile => {
        if (selectedMediaFile) {
          this.selectedMediaFile = selectedMediaFile;
          this.noticeBoardForm.patchValue({
            mediaFileId: selectedMediaFile.id
          });
        }
      }
    );
  }

  ngOnDestroy() {
    this.mediaFileService.changeSelectedMediaFile(null);
  }

  bindDropDown() {
    this.noticeBoardCategoryService.getAllNoticeBoardCategories().subscribe((response: INoticeBoardCategory[]) => {
      if (response) {
        this.noticeBoardCategories = response;
      }
    });
  }

  createNoticeBoardForm() {
    this.noticeBoardForm = this.fb.group({
      id: ['0', Validators.required],
      content: ['<p>Type here..</p>', Validators.required],
      isActive: [''],
      isNew: [''],
      noticeBoardCategoryId: [''],
      mediaFileId: ['']
    });
  }

  setValueNoticeBoardForm() {
    this.noticeBoardForm.patchValue({
      id: this.noticeBoard.id,
      content: this.noticeBoard.content,
      isActive: this.noticeBoard.isActive,
      isNew: this.noticeBoard.isNew,
      mediaFileId: this.noticeBoard.mediaFileId,
      noticeBoardCategoryId: this.noticeBoard.noticeBoardCategoryId
    });
  }

  save() {
    if (this.noticeBoardForm.valid) {
      this.loading = true;
      this.noticeBoard = Object.assign({}, this.noticeBoardForm.value);
      if (this.id) {
        this.service.update(this.id, this.noticeBoard).subscribe(() => {
          this.toastrService.success('Notice updated successful');
          this.router.navigate(['/admin/notice-boards']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.noticeBoard).subscribe(() => {
          this.toastrService.success('Notice created successful');
          this.router.navigate(['/admin/notice-boards']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  delete() {
    if (!confirm('Are you sure you want to delete this Notice?')) return;

    this.service.delete(this.id).subscribe(() => {
      this.toastrService.success('Notice deleted successful');
      this.router.navigate(['/admin/notice-boards']);
    });
  }

  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
  }

  OnSubmit(inputDoc) {

    this.mediaFileService.authPostSingleFile(this.fileToUpload).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.isProgress = true;
          this.barWidth = Math.round(event.loaded / event.total * 100);
        }
        else if (event.type === HttpEventType.Response) {
          this.isProgress = false;
          this.barWidth = 0;
          this.noticeBoardForm.patchValue({
            mediaFileId: event.body.id
          });
        }
      },
      (error) => {
        console.log(error);
        inputDoc.value = null;
      },
      () => console.log("complete"));
  }

}
